import { ArrowDownCircleIcon } from './ArrowDownCircleIcon';

/**
 * author: Austin Andrews
 * id 51D021A8-C3E1-477C-8BBF-DD4B84549515
 * name arrow-down-circle
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-circle.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomCircleIcon = ArrowDownCircleIcon;
export default ArrowBottomCircleIcon